import { isPortfolioItemExtended } from 'utils/portfolio';
import { PcwStep } from './types';
import { PortfolioItemExtended } from 'types/portfolios';
import mappedItemTypes from 'services/items/mappedItemTypes';
import { PCW_STEPS } from './constants';

export const portfolioTypeStepNavigation = (): PcwStep => {
    return 'portfolio-basics';
};

export const ancillariesStepNavigation = (_: any, formData: any): PcwStep => {
    // If the user has selected either Batteries, Thermal item or a Hydro Project item, navigate to ancillaries
    const hydroData = formData?.[PCW_STEPS.PCW_HYDRO_STEP_ID]?.selected;
    if (Array.isArray(hydroData) && hydroData.length > 0) {
        const hasHydroProjectData = hydroData.some(
            (item: any) => isPortfolioItemExtended(item) && item.typeId === mappedItemTypes.HYDRO_PROJECT.id
        );
        if (hasHydroProjectData) {
            return 'add-ancillaries';
        }
    }

    const batteryData = formData?.[PCW_STEPS.PCW_ADD_BATTERY_STEP_ID]?.selected;
    if (Array.isArray(batteryData) && batteryData.length > 0) {
        const hasBattery = batteryData.some(
            (item: PortfolioItemExtended) =>
                isPortfolioItemExtended(item) && item.typeId === mappedItemTypes.BATTERY_STORAGE.id
        );
        if (hasBattery) {
            return 'add-ancillaries';
        }
    }

    const generationAssetData = formData?.[PCW_STEPS.PCW_ADD_GENERATION_ASSET_STEP_ID]?.selected;
    if (Array.isArray(generationAssetData) && generationAssetData.length > 0) {
        const hasThermal = generationAssetData.some(
            (item: PortfolioItemExtended) =>
                isPortfolioItemExtended(item) && item.typeId === mappedItemTypes.GENERATION_ASSET.id
        );
        if (hasThermal) {
            return 'add-ancillaries';
        }
    }

    return 'add-hedges-contracts';
};
